import { useState } from 'react';
import { Layout, Tooltip } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, HomeOutlined, RobotOutlined, BarChartOutlined } from '@ant-design/icons';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import { Button } from 'antd';
import { t, getLang } from '../utils/i18n';

const { Sider } = Layout;

const FullLayout = () => {
  const [collapsed, setCollapsed] = useState(true); // 默认折叠
  const [lang, setLangState] = useState(getLang());
  const navigate = useNavigate();

  return (
    <Layout className="user-layout" hasSider>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        trigger={null}
        width={240}
        collapsedWidth={72}
        className="user-sider"
      >
        {/* Logo */}
        <Link to="/" className="sidebar-logo">
          <img src={require('../utils/img/logo.png')} alt="Blue API" className="logo-icon" />
          {!collapsed && <span className="logo-text">Blue API</span>}
        </Link>

        {/* 菜单 */}
        <div className="sidebar-menu-wrapper">
          <div
            className="sidebar-menu"
            style={{ padding: '0 0 16px 0' }}
          >
            <Tooltip title={collapsed ? t('expand_menu') : t('collapse_menu')} placement="right">
              <div
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  cursor: 'pointer',
                  fontSize: 16,
                  color: '#6b7280',
                  width: '100%',
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  paddingLeft: collapsed ? 0 : 24,
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                {!collapsed && <span style={{ marginLeft: 12, fontSize: 14 }}>{t('collapse')}</span>}
              </div>
            </Tooltip>
            <Tooltip title={t('model_square')} placement="right">
              <div
                onClick={() => navigate('/dashboard/models')}
                style={{
                  cursor: 'pointer',
                  fontSize: 14,
                  color: '#6b7280',
                  width: '100%',
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  paddingLeft: collapsed ? 0 : 24,
                  marginTop: 8,
                  transition: 'all 0.2s',
                  borderRadius: 0,
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                <RobotOutlined />
                {!collapsed && <span style={{ marginLeft: 12 }}>{t('model_square')}</span>}
              </div>
            </Tooltip>
            <Tooltip title={t('price_compare')} placement="right">
              <div
                onClick={() => navigate('/compare')}
                style={{
                  cursor: 'pointer',
                  fontSize: 14,
                  color: '#6b7280',
                  width: '100%',
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  paddingLeft: collapsed ? 0 : 24,
                  marginTop: 8,
                  transition: 'all 0.2s',
                  borderRadius: 0,
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                <BarChartOutlined />
                {!collapsed && <span style={{ marginLeft: 12 }}>{t('price_compare')}</span>}
              </div>
            </Tooltip>
            <Tooltip title={t('back_to_console')} placement="right">
              <div
                onClick={() => navigate('/dashboard')}
                style={{
                  cursor: 'pointer',
                  fontSize: 14,
                  color: '#6b7280',
                  width: '100%',
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  paddingLeft: collapsed ? 0 : 24,
                  marginTop: 8,
                  transition: 'all 0.2s',
                  borderRadius: 0,
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                <HomeOutlined />
                {!collapsed && <span style={{ marginLeft: 12 }}>{t('back_to_console')}</span>}
              </div>
            </Tooltip>
          </div>
        </div>
      </Sider>

      {/* 右侧内容区 - 无 Header */}
      <div className={`user-content-wrapper ${collapsed ? 'user-sider-collapsed' : ''}`} style={{ paddingTop: 0 }}>
        {/* 可滚动内容区 */}
        <div className="user-content" style={{ paddingTop: 0 }}>
          <Outlet />
        </div>
      </div>
    </Layout>
  );
};

export default FullLayout;
